import Vuex from "vuex";
import Vue from "vue";
import {findGetParameter, getFileMimeType, md5, parseDuration} from '@/common/utils';
import {getChapters, getData} from '@/common/api';
import { MUTATION_PUSH, MUTATION_UPDATE } from "@/store/mutations";
import {
  ACTION_INIT_PLAYER,
  ACTION_NEXT_TRACK,
  ACTION_PREVIOUS_TRACK, ACTION_UPDATE_CHAPTERS,
} from '@/store/actions';
import { skinColors } from "@/constants";
import {getFontColor,isVideo } from "../common/utils";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    /**
     * @type {Components.Schemas.PlayerSettingDTO}
     */
    setting: null,
    /**
     * @type {Components.Schemas.PlayerEpisodeItemDTO[]}
     */
    episodes: null,
    error: null,
    errorLogo: null,
    errorLoginUrl: null,
    current: null,
    skin: 1,
    btnSkin: 7,
    download: 1,
    share: 1,
    info: 1,
    rtl: 0,
    logoLink:"episode_page",
    fonts: "Helvetica",
    startAt: 0,
    square: 0,
    mini: 0,
    showAppDownloadStatus: 0,
    isNonAppDownloadDialogOpen: false,
    start:0,
    stop:0,
    recordedFFTData:[],
    playing : false,
    playerLoading: false,
    playerLoaded: false,
    playerError:false,
    playerPlaying:false,
    screenshotImg: "",
    playbackRate:1,
    playbackRateIndex:1,
    podcastApps:[],
    rssPageLink: null,
    customCssLink: null,
    customCss: null,
    playerColor: null,
    playerBtnColor: null,
    fontColor: null,
    fontColorInput: null,
    miniOnlyPlay: 0,
    chapters: [],
    cssVersion: Math.floor(Math.random() * 1000000000).toString(16),
    showFullScreenToggle:true
  },
  mutations: {
    [MUTATION_UPDATE](state, [key, value]) {
      state[key] = value;
      if (key === "current") {
        /**
         * @param episode {Components.Schemas.PlayerEpisodeItemDTO}
         */
        if ("mediaSession" in navigator && store.getters.episode && store.getters.episode.logo) {
          navigator.mediaSession.metadata = new window.MediaMetadata({
            title: store.getters.episode.title,
            artist: state.setting.author,
            album: state.setting.podcastTitle,
            artwork: [
              {
                sizes: "300x300",
                src: store.getters.episode.logo
              }
            ]
          });
        }
        store.dispatch(ACTION_UPDATE_CHAPTERS);
      }
    },
    [MUTATION_PUSH](state, [key, value]) {
      state[key].push(value);
    }
  },
  getters: {
    /**
     *
     * @param state
     * @returns {Components.Schemas.PlayerEpisodeItemDTO}
     */
    episode: state => {
      return state.episodes && state.episodes[state.current];
    },
    skinColor: state => {
      return state.playerColor ? state.playerColor : skinColors[state.skin];
    },
    btnSkinColor: state => {
      return state.playerBtnColor ? state.playerBtnColor : skinColors[state.btnSkin];
    }
  },
  actions: {
    async [ACTION_UPDATE_CHAPTERS]({ commit, state }) {
      let chapters = [];
      if(store.getters.episode && store.getters.episode.chaptersUrl){
        chapters = await getChapters(store.getters.episode.chaptersUrl);
      }
      commit(MUTATION_UPDATE, ["chapters", chapters]);
    },
    async [ACTION_NEXT_TRACK]({ commit, state }) {
      if (state.current + 1 >= state.episodes.length) {
        // commit(MUTATION_UPDATE,['current',0]);
      } else {
        commit(MUTATION_UPDATE, ["current", state.current + 1]);
      }
    },
    async [ACTION_PREVIOUS_TRACK]({ commit, state }) {
      if (state.current - 1 >= 0) {
        commit(MUTATION_UPDATE, ["current", state.current - 1]);
      } else {
        commit(MUTATION_UPDATE, ["current", state.episodes.length - 1]);
      }
    },
    async [ACTION_INIT_PLAYER]({ commit }) {
      if (findGetParameter("debug_loading")){
        return;
      }
      let media = findGetParameter("media") || "";
      let id = findGetParameter("i");
      let scode = findGetParameter("scode") || "";
      let pfauth = findGetParameter("pfauth") || "";
      let noPbAd = findGetParameter("pbad") === "0";
      let order = findGetParameter("order");
      let limit = findGetParameter("limit");
      let filter = findGetParameter("filter");
      let publish_start = findGetParameter("publish_start");
      let publish_end = findGetParameter("publish_end");
      let season = findGetParameter("season");
      let tag = findGetParameter("tag");
      let ss = findGetParameter("ss");
      let mini = parseInt(findGetParameter("mini")) || 0;
      let skin = findGetParameter("skin");
      let playerColor;
      let SKIN_COLORS = {
          1 : 'f6f6f6',
          2 : '1b1b1b',
          3 : '3267a3',
          4 : '60a0c8',
          5 : '2baf9e',
          6 : '3ab278',
          7 : '8bbb4e',
          8 : 'ff6d00',
          9 : 'c73a3a',
          10 : '956f46',
          11 : '654771',
          12 : '666666',
          13 : 'fb0584',
      };
      if(skin){
        if(skin.length <= 2) {
          skin = parseInt(skin) || 1;
          skin = SKIN_COLORS[skin] || SKIN_COLORS[1];
        }else if(skin.length > 6 || !/^\w+$/.test(skin)){
          skin = SKIN_COLORS[1];
        }
        playerColor = '#'+skin
      }

      let btnSkin = findGetParameter("btn-skin");
      let playerBtnColor;
      if(btnSkin){
        if(btnSkin.length <= 2) {
          btnSkin = parseInt(btnSkin) || 7;
          btnSkin = SKIN_COLORS[btnSkin] || SKIN_COLORS[7];
        }else if(btnSkin.length > 6 || !/^\w+$/.test(btnSkin)){
          btnSkin = SKIN_COLORS[7];
        }
        playerBtnColor = '#'+btnSkin
      }
      let fontColorInput = findGetParameter("font-color");
      if(fontColorInput && fontColorInput.length !== 6 || !/^\w+$/.test(fontColorInput)){
        fontColorInput = null;
      }
      let fontColor = getFontColor(fontColorInput,playerColor);
      let square = parseInt(findGetParameter("square")) || 0;
      commit(MUTATION_UPDATE, [
        "square",
        square
      ]);
      let res;
      try {
        if (media){

          let p = findGetParameter("p") || '';
          let e = findGetParameter("e") || '';
          let t = findGetParameter("t") || '';
          let et = findGetParameter("et") || '';
          let pt = findGetParameter("pt") || '';
          let au = findGetParameter("au") || '';
          let l = findGetParameter("l") || '';
          let f = findGetParameter("f") || '';
          let s = findGetParameter("s") || '';

          let transcriptsUrl = findGetParameter("transcripts") || '';
          let egt = findGetParameter("egt");

          if(md5(`${media}-${p}-${e}-${t}-${et}-${pt}-${au}-${l}-${f}-${transcriptsUrl}-pb20210519vcx_mini`)!==s){
            throw new Error('Invalid params');
          }

          let mediaType = 'audio';
          if(isVideo(media)){
            mediaType = 'video';
          }

          res = {
            "setting": {
              "podcastTitle": pt,
              "podcastLink": "https://www.podbean.com",
              "author": au,
              "engagementStatsBaseUrl":egt,
            },
            "episodes": [{
              "id":e,
              "title":et,
              "protectedLevel": "public",
              "resource": media,
              "resourceMimetype": getFileMimeType(media),
              "type": mediaType,
              "logo": l,
              "largeLogo":l,
              "enableWave": false,
              "enableSpeed": false,
              "crossorigin": "anonymous",
              "transcripts_url": transcriptsUrl
            }],
            podcastApps:[],
          }
          mini = 1;
          btnSkin = skin;
          playerBtnColor = playerColor;
          commit(MUTATION_UPDATE,[
            "showFullScreenToggle",
            false
          ])
        }else{

          res = await getData(id, {
            scode,
            pfauth,
            referrer: scode?document.referrer:'',
            order,
            limit,
            filter,
            publish_start,
            publish_end,
            season,
            tag,
            ss,
            touchable:navigator.maxTouchPoints>1,
            type: id.indexOf("-playlist") !== -1 ? 'playlist' : (square===1?'stylish':'classic')
          });
        }
      } catch (e) {
        if (noPbAd) {
          commit(MUTATION_UPDATE, [
            "error",
            "www.podbean.com refused to connect"
          ]);
        } else {
          commit(MUTATION_UPDATE, [
            "error",
            "www.podbean.com refused to connect"
          ]);
        }
        return;
      } finally {

        let loading = document.getElementById("global-loading");
        let maskLogo = document.getElementById("mask-logo");
        maskLogo.addEventListener(
          "animationiteration",
          () => {
            loading.style.opacity = 0;
            maskLogo.classList.remove("on");
          },
          false
        );
        loading.addEventListener(
          "transitionend",
          () => {
            loading.style.display = "none";
          },
          false
        );
      }
      if(res){
        commit(MUTATION_UPDATE, ["episodes", res.episodes]);
        commit(MUTATION_UPDATE, ["setting", res.setting]);
        commit(MUTATION_UPDATE, ["screenshotImg", res.screenshotImg]);
        commit(MUTATION_UPDATE, ["podcastApps", res.podcastApps]);
        commit(MUTATION_UPDATE, ["rssPageLink", res.rssPageLink]);
        commit(MUTATION_UPDATE, ["customCssLink", res.customCssLink]);
      }
      commit(MUTATION_UPDATE, [
        "skin",
        skin
      ]);
      commit(MUTATION_UPDATE, [
        "btnSkin",
        btnSkin
      ]);

      commit(MUTATION_UPDATE, [
        "playerColor",
        playerColor
      ]);

      commit(MUTATION_UPDATE, [
        "playerBtnColor",
        playerBtnColor
      ]);

      commit(MUTATION_UPDATE, [
        "fontColor",
        fontColor
      ]);

      commit(MUTATION_UPDATE, [
        "fontColorInput",
        fontColorInput
      ]);

      if (!findGetParameter("download")) {
        commit(MUTATION_UPDATE, ["download", 1]);
      } else {
        commit(MUTATION_UPDATE, [
          "download",
          parseInt(findGetParameter("download"))
        ]);
      }

      if (!findGetParameter("share")) {
        commit(MUTATION_UPDATE, ["share", 1]);
      } else {
        commit(MUTATION_UPDATE, ["share", parseInt(findGetParameter("share"))]);
      }

      if (!findGetParameter("info")) {
        commit(MUTATION_UPDATE, ["info", 1]);
      } else {
        commit(MUTATION_UPDATE, ["info", parseInt(findGetParameter("info"))]);
      }

      commit(MUTATION_UPDATE, ["rtl", parseInt(findGetParameter("rtl")) || 0]);
      commit(MUTATION_UPDATE, ["logoLink", findGetParameter("logo_link") || "episode_page"]);
      commit(MUTATION_UPDATE, [
        "fonts",
        findGetParameter("fonts") || "Helvetica"
      ]);
      commit(MUTATION_UPDATE, [
        "startAt",
        parseInt(findGetParameter("start_at")) || 0
      ]);


      commit(MUTATION_UPDATE, [
        "mini",
        mini
      ]);

      commit(MUTATION_UPDATE, ["current", 0]);

      commit(MUTATION_UPDATE, ["miniOnlyPlay", parseInt(findGetParameter("mini-only-play")) || 0]);

      if ("mediaSession" in navigator) {
        if (res && res.episodes.length > 1) {
          navigator.mediaSession.setActionHandler("previoustrack", () => {
            store.dispatch(ACTION_PREVIOUS_TRACK);
          });
          navigator.mediaSession.setActionHandler("nexttrack", () => {
            store.dispatch(ACTION_NEXT_TRACK);
          });
        }
      }
    }
  }
});

window.addEventListener("message", event => {
  if (
    typeof event.data === "object" &&
    event.data.action &&
    event.data.action.search("PB.Widget.API.") !== -1
  ) {
    try {
      var action = event.data.action.replace("PB.Widget.API.", "");
      switch (action) {
        case "CHANGE_PARAMS":
          if (
            ["skin", "btn-skin", "download", "share", "info", "rtl", "fonts", "font-color"].indexOf(
              event.data.key
            ) === -1
          ) {
            return;
          }
          // eslint-disable-next-line no-case-declarations
          let key = event.data.key;
          // eslint-disable-next-line no-case-declarations
          let value = event.data.value;
          if (
            ["download", "share", "info", "rtl"].indexOf(
              event.data.key
            ) !== -1
          ) {
            value = parseInt(value);
          }else if (
            "skin" === event.data.key
          ) {
              let playerColor = null;
              if(value.length <= 2) {
                value = parseInt(value);
              }else if(value.length <=6 && /^\w+$/.test(value)){
                store.commit(MUTATION_UPDATE, ['playerColor', '#'+value]);
                playerColor = '#'+value;
              }else{
                value = 1;
              }
              let fontColor = getFontColor(store.state.fontColorInput,playerColor);
              store.commit(MUTATION_UPDATE, ['fontColor', fontColor]);
          }else if (
            "btn-skin" === event.data.key
          ) {
              if(value.length <= 2) {
                value = parseInt(value);
              }else if(value.length <=6 && /^\w+$/.test(value)){
                store.commit(MUTATION_UPDATE, ['playerBtnColor', '#'+value]);
              }else{
                value = 7;
              }
          }else if(key === 'font-color'){
            key = "fontColor"
            if(value.length !== 6 || !/^\w+$/.test(value)){
              value=null;
            }
            store.commit(MUTATION_UPDATE,['fontColorInput',value])
            value = getFontColor(value,store.state.playerColor);
          }
          if (key === "btn-skin") {
            key = "btnSkin";
          }

          store.commit(MUTATION_UPDATE, [key, value]);
          break;
        case "CHANGE_CUSTOM_CSS":
          store.commit(MUTATION_UPDATE, ['customCss', event.data.value]);
          break;
      }
    } catch (e) {
      console.error(e);
    }
  }
});
